import {
  CLICK_ACTIONS,
  DEFAULT_OPTION,
  DEFAULT_OPTION_TRACK_COMPLAINT,
} from '../../utils/Constant';
import {
  ColumnHeaderType,
  EmployeeNameType,
  SelectOptionType,
  TrackComplaintsDetailedType,
  TrackCompliantFilterType,
} from '../../utils/Types';
import {
  blankValueGetter,
  formattedDateWithFormat,
  isAPIFailed,
  isAPISuccess,
} from '../../utils/Util';
import resolvedIcon from '../../assets/img/check-mark_resolved.svg';
import inProgressIcon from '../../assets/img/inprogress.svg';
import { ThunkDispatch } from 'redux-thunk';
import {
  assignTheEmployee,
  getDetailedComplaint,
} from '../../features/trackComplaintsSlice';
import { toast } from 'react-toastify';

export const moduleIds = {
  status: 9,
};

export const severityIds = {
  low: 4,
  medium: 3,
  high: 2,
  veryHigh: 1,
};

export const statusIds = {
  new: 35,
  inProgress: 36,
  resolved: 37,
  unResolved: 38,
};

export const followUpId = 36;

export const TRACK_COMPLIANT_HEADER: ColumnHeaderType[] = [
  {
    name: 'Complaint Id',
    field: 'complaintUniqueId',
    action: CLICK_ACTIONS.APPROVE,
    clickable: true,
  },
  {
    name: 'Customer Name',
    field: 'customerName',
    valueGetter: blankValueGetter,
  },
  {
    name: 'Customer Mobile Number',
    field: 'customerNumber',
    valueGetter: blankValueGetter,
  },
  {
    name: 'Issue Subject',
    field: 'issueSubject',
    valueGetter: blankValueGetter,
    toolTipAfter: 25,
  },
  {
    name: 'Raise Date & Time',
    field: 'createdOn',
    valueGetter: (data: any, field?: string) => {
      return formattedDateWithFormat(
        String(data[field as keyof any]),
        'DD-MM-YYYY hh:mm A'
      );
    },
  },
  {
    name: 'Severity',
    field: 'severityName',
    valueGetter: blankValueGetter,
    classNameGetter: (data: any) => {
      if (
        data.severityId == severityIds.high ||
        data.severityId == severityIds.veryHigh
      )
        return 'text-danger';
      else if (data.severityId == severityIds.medium) return 'text-warning';
      else if (data.severityId == severityIds.low) return 'text-primary';

      return 'text-normal';
    },
  },
  {
    name: 'Status',
    field: 'complaintStatusName',
    leftIcon: (data: any) => {
      if (data.complaintStatus == statusIds.inProgress) {
        return inProgressIcon;
      } else if (data.complaintStatus == statusIds.resolved) {
        return resolvedIcon;
      }
      return '';
    },
    classNameGetter: (data: any) => {
      if (data.complaintStatus == statusIds.resolved) return 'text-success';
      if (data.complaintStatus == statusIds.inProgress) return 'text-warning';

      return 'text-normal';
    },
  },
];

export const getFollowUpStatusDefault = (
  statusDropOptions: any[],
  filter: TrackCompliantFilterType
) => {
  let followUpStatusOption = DEFAULT_OPTION;
  if (statusDropOptions?.length) {
    const markedDropLabel = statusDropOptions?.filter(
      (item: any) => item?.value === followUpId
    );
    if (markedDropLabel?.length) {
      followUpStatusOption = markedDropLabel?.[0];
    }
  }

  return {
    ...filter,
    status: followUpStatusOption,
  };
};

export const getComplaintDetails = (
  dispatch: ThunkDispatch<any, any, any>,
  setShowLoader: (value: boolean) => void,
  complaintId?: string | number | null
) => {
  if (complaintId) {
    setShowLoader(true);
    dispatch(getDetailedComplaint({ complaintTrackId: complaintId }))
      ?.then(() => {
        setShowLoader(false);
      })
      ?.catch(() => {
        setShowLoader(false);
      });
  }
};

export const assignEmployee = (
  trackCompliantDetails: TrackComplaintsDetailedType,
  employeeList: EmployeeNameType[],
  employee: SelectOptionType,
  dispatch: ThunkDispatch<any, any, any>,
  setShowLoader: (value: boolean) => void,
  complaintId?: string | number | null
) => {
  if (
    trackCompliantDetails.taskDetails?.assignedToEmployeeUniqueId !=
    employee?.value
  ) {
    const employeeDetails = employeeList.find(
      (emp) => emp.employeeUniqueId === employee?.value
    );
    if (employeeDetails?.candidateId) {
      setShowLoader(true);
      dispatch(
        assignTheEmployee({
          complaintTrackId: trackCompliantDetails.complaintTrackId,
          assignedToId: employeeDetails.candidateId,
        })
      )
        ?.then((fulfilled: any) => {
          if (isAPISuccess(fulfilled?.payload)) {
            getComplaintDetails(dispatch, setShowLoader, complaintId);
          } else if (isAPIFailed(fulfilled?.payload)) {
            toast.error(fulfilled?.payload.responseInformation.responseMessage);
          }
          setShowLoader(false);
        })
        ?.catch(() => {
          setShowLoader(false);
          toast.error('Assign Employee Failed!');
        });
    }
  }
};
export const updateEmployee = (
  trackCompliantDetails: TrackComplaintsDetailedType,
  setEmployee: (value: SelectOptionType) => void
) => {
  if (trackCompliantDetails.taskDetails?.assignedToEmployeeUniqueId) {
    setEmployee({
      label: trackCompliantDetails.taskDetails.assignedToName,
      value: trackCompliantDetails.taskDetails.assignedToEmployeeUniqueId,
    });
  } else {
    setEmployee(DEFAULT_OPTION_TRACK_COMPLAINT);
  }
};
